// extracted by mini-css-extract-plugin
export default {"categoryBar":"CategoryBar-module__categoryBar___3U9Y2"};